import { render, staticRenderFns } from "./RegistroAlojamiento.vue?vue&type=template&id=45544f18&scoped=true&"
import script from "./RegistroAlojamiento.vue?vue&type=script&lang=js&"
export * from "./RegistroAlojamiento.vue?vue&type=script&lang=js&"
import style0 from "./RegistroAlojamiento.vue?vue&type=style&index=0&id=45544f18&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "45544f18",
  null
  
)

export default component.exports